import Vue from 'vue';
import Vuetify, {
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelContent,
  VExpansionPanelHeader,
} from 'vuetify/lib';
import ja from 'vuetify/src/locale/ja';

Vue.use(Vuetify, {
  components: {
    VExpansionPanel,
    VExpansionPanels,
    VExpansionPanelContent,
    VExpansionPanelHeader,
  },
});

export default new Vuetify({
  theme: {
    // primary: '#231815',
    primary: '#363829',
    secondary: '#ffda01',
    white: '#ffffff',
    error: '#e60012',
    blue: '#2d72c3',
    red: '#c32d2d',
    icon: '#363829'
  },
  lang: {
    locales: { ja },
    current: "ja"
  },
  icons: {
    iconfont: 'mdi',
    'search': 'mdi-magnify',
    'check': 'mdi-check',
    'delete': 'mdi-trash-can-outline',
    'right': 'mdi-chevron-right',
    'tilde': 'mdi-tilde',
    'minus': 'mdi-minus',
    'at': 'mdi-at',
    'menu': 'mdi-menu',
    'check-underline': 'mdi-check-underline'
  }
});
